import React from 'react';

class SubscribeForm extends React.Component {
  render() {
    return (
      <div className="max-w-md mx-auto" id="mc_embed_signup">
        <form
          action="https://gmail.us14.list-manage.com/subscribe/post?u=77659d2812a4288655d5c7c77&amp;id=73d6f80825"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank"
          noValidate
        >
          <div id="mc_embed_signup_scroll" className="flex flex-col sm:flex-row gap-3">
            <div className="flex-1">
              <input 
                type="email" 
                name="EMAIL" 
                className="w-full py-3 px-4 rounded-xl border-2 border-white/30 text-gray-800 bg-white/90 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:border-secondary focus:bg-white transition-all duration-200" 
                id="mce-EMAIL" 
                placeholder="Enter your email address" 
                required 
              />
            </div>
            
            {/* Honeypot field */}
            <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
              <input
                type="text"
                name="b_77659d2812a4288655d5c7c77_73d6f80825"
                tabIndex="-1"
              />
            </div>
            
            <button 
              type="submit" 
              name="subscribe" 
              id="mc-embedded-subscribe" 
              className="btn-gold bg-white text-primary border-white hover:bg-primary hover:text-white py-3 px-6 rounded-xl font-semibold transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg whitespace-nowrap"
            >
              Subscribe
            </button>
          </div>
          
          {/* Privacy note */}
          <p className="text-xs text-green-200 mt-3 text-center">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </form>
      </div>
    );
  }
}

export default SubscribeForm;
